export const isRunningAsPwa = () => {
  const standalone = window.matchMedia('(display-mode: standalone)').matches;
  const fullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;

  return standalone || iosStandalone || (fullscreen && !document.fullscreenElement);
};
